export default "__VITE_ASSET__BtO1zSrm__"